import { render, staticRenderFns } from "./MtMaterialsList.vue?vue&type=template&id=61caf0f8&scoped=true&"
import script from "./MtMaterialsList.vue?vue&type=script&lang=js&"
export * from "./MtMaterialsList.vue?vue&type=script&lang=js&"
import style0 from "./MtMaterialsList.vue?vue&type=style&index=0&id=61caf0f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61caf0f8",
  null
  
)

export default component.exports